module.exports = __webpack_public_path__ + "static/img/s8.3c2de86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s8.png
// module id = HLDf
// module chunks = 0